import defaultPlatformHelpers from 'Stores/_default-store/platformHelpers';

export type StoragePermissions = {
  analytics: boolean | null;
  functional: boolean | null;
};

export interface PlatformHelpers {
  initializePlatformHelpers(): void;
  initializePlatformStorage(onStoragePermissionsChanged: () => void): void | Promise<void>;
  getStoragePermissions(): StoragePermissions;
}

const platformHelpers: PlatformHelpers = {
  initializePlatformHelpers(): void {},
  initializePlatformStorage(): void {},
  getStoragePermissions(): StoragePermissions {
    return { analytics: true, functional: true };
  },
  ...defaultPlatformHelpers,
};

export default platformHelpers;
